<!--Create View-->
<form [formGroup]="formGroup" autocomplete="off" *ngIf="!isEditView">
  <section class="company-form-description col-12 pr-0 pl-0" *ngIf="placement !== enumPlacement.COMPANY_PAGE">
    <span class="company-form-description__header">{{ "COMPANY.EDIT_FORM_HEADER" | translate }}</span>
    <span class="company-form-description__text">
      {{ (isEditViewFromBondsPage ? "COMPANY.EDIT_FORM_TEXT_FROM_BONDS" : "COMPANY.EDIT_FORM_TEXT") | translate }}
    </span>
  </section>

  <!--    business info -->
  <section
    class="form-section"
    id="business-info-section"
    [ngClass]="{ 'form-section__company-page': placement === enumPlacement.COMPANY_PAGE }"
  >
    <company-business-info-form
      [company]="company"
      [isEditView]="isEditView"
      [formGroup]="formGroup"
      [isFirstCompany]="isFirstCompany"
      [isShowBusinessLocation]="!isHasOnboardingRedesign"
      [isShowDescription]="placement === enumPlacement.COMPANY_PAGE"
      [isRegistrationInProcess]="isRegistrationInProcess"
      [lastDependencyErrorCodes]="lastDependencyErrorCodes"
      [lastDependency]="lastDependency"
      [ss4Document]="ss4Document"
      [ss4DownloadUrl]="ss4DownloadUrl"
      [isLoadingSs4]="isLoadingSs4"
      [isSs4Image]="ss4IsImage"
      [isPoaGrandfathered]="isPoaGrandfathered"
      (applyForAssignedCbpNumber)="applyForAssignedCbpNumber()"
      (ss4Selected$)="updateSs4Control($event)"
    ></company-business-info-form>
  </section>

  <!--    user phone -->
  <section class="form-section" id="user-phone-section" *ngIf="showUserPhone">
    <company-user-phone [formGroup]="formGroup"></company-user-phone>
  </section>

  <!--    business address -->
  <section
    class="form-section"
    id="business-address-section"
    [ngClass]="{ 'form-section__company-page': placement === enumPlacement.COMPANY_PAGE }"
  >
    <company-address-form
      [formGroup]="formGroup"
      [isShowDescription]="placement === enumPlacement.COMPANY_PAGE"
      [isDisableCountry]="isDisableCountry"
    ></company-address-form>
  </section>

  <!--    #13269 controlling persons (beneficial owners / partners) -->
  <section
    class="form-section"
    id="controlling-persons-section"
    *ngIf="placement === enumPlacement.COMPANY_PAGE"
    [ngClass]="{ 'form-section__company-page': placement === enumPlacement.COMPANY_PAGE }"
  >
    <company-controlling-persons-form
      [formGroup]="formGroup"
      [isShowDescription]="placement === enumPlacement.COMPANY_PAGE"
      [personDocuments]="controllingPersonDocuments"
      [scanBuffer]="controllingPersonScans"
      [scanUrls]="controllingPersonScanUrls"
      [uploadingGroups]="controllingPersonUploadingGroups"
      [scanErrors]="controllingPersonScanErrors"
      (scanSelected$)="onControllingPersonScanSelected($event)"
      (personRemoved$)="onControllingPersonRemoved($event)"
      (retryScanUpload$)="onControllingPersonScanRetry($event)"
    ></company-controlling-persons-form>
  </section>

  <!--    IOR contact information -->
  <section
    class="form-section"
    id="ior-contact-section"
    [ngClass]="{ 'form-section__company-page': placement === enumPlacement.COMPANY_PAGE }"
  >
    <company-ior-contact-form
      [formGroup]="formGroup"
      [isShowDescription]="placement === enumPlacement.COMPANY_PAGE"
    ></company-ior-contact-form>
  </section>

  <!--    Employee status -->
  <section
    *ngIf="showEmployeeStatus"
    class="form-section"
    id="employee-status-section"
    [ngClass]="{ 'form-section__company-page': placement === enumPlacement.COMPANY_PAGE }"
  >
    <company-employee-status [organization]="organization"></company-employee-status>
  </section>

  <!--  shipping role -->
  <section
    class="form-section"
    id="shipping-profile-definitions"
    *ngIf="placement === enumPlacement.COMPANY_PAGE && !isHasOnboardingRedesign"
    [ngClass]="{ 'form-section__company-page': placement === enumPlacement.COMPANY_PAGE }"
  >
    <company-shipping-role [formGroup]="formGroup" [isShowDescription]="placement === enumPlacement.COMPANY_PAGE"></company-shipping-role>
  </section>

  <!--  Power of attorney-->
  <section
    id="power-of-attorney"
    *ngIf="
      ((!formGroup.controls.isUnitedStates.value && formGroup.controls.isAllowedForCustoms.value) ||
        formGroup.controls.isUnitedStates.value) &&
      placement === enumPlacement.COMPANY_PAGE
    "
  >
    <ng-container *ngIf="isPoaDocusignEnabled; else legacyPoaTop">
      <company-power-attorney
        [poaDocument]="poaDocument"
        [companyId]="company?.id"
        [organizationId]="organization?.id"
        [isShowSubheader]="true"
        [isShowDescription]="!poaDocument"
        [isLoadingCompanyPoa]="isLoadingCompanyPoa"
        [isTablet]="isTablet$ | async"
        [isRegistrationApproved]="lastDependency?.state === enumDependencyState.ACCEPTED"
        [identifierQualifier]="identifierQualifier"
        [allowManualBeforeApproval]="isEditView"
        [isRequiredFieldsComplete]="isPoaFieldsComplete"
        (uploadDocument)="uploadDocument($event, enumDocument.POWER_OF_ATTORNEY)"
        (deleteDocument)="deleteDocument($event, enumDocument.POWER_OF_ATTORNEY)"
        (updateDocumentState)="updateDocumentState(poaDocument.id, $event)"
        (requestSaveBeforeSign)="onSaveBeforeDigitalSign()"
      ></company-power-attorney>
    </ng-container>
    <ng-template #legacyPoaTop>
      <company-power-attorney-old
        [poaDocument]="poaDocument"
        [isShowDescription]="placement === enumPlacement.COMPANY_PAGE"
        [isShowSubheader]="placement === enumPlacement.COMPANY_PAGE"
        [isLoadingCompanyPoa]="isLoadingCompanyPoa"
        [isTablet]="isTablet$ | async"
        (uploadDocument)="uploadDocument($event, enumDocument.POWER_OF_ATTORNEY)"
        (deleteDocument)="deleteDocument($event, enumDocument.POWER_OF_ATTORNEY)"
        (updateDocumentState)="updateDocumentState(poaDocument.id, $event)"
      ></company-power-attorney-old>
    </ng-template>
  </section>

  <!--  company logo / photo id -->
  <section
    class="form-section"
    id="company-logo"
    *ngIf="placement === enumPlacement.COMPANY_PAGE"
    [ngClass]="{ 'form-section__company-page': placement === enumPlacement.COMPANY_PAGE }"
  >
    <company-photo-id-form
      *ngIf="isPhotoIdBusinessType; else logoFormCreate"
      [photoIdUri]="photoIdDownloadUrl"
      [companyId]="companyId"
      [isLoading]="isLoadingPhotoId"
      [isNonImageDocument]="!!photoIdDocument && !photoIdIsImage"
      [fileName]="photoIdDocument?.fileName"
      (uploadPhotoIdSource$)="updatePhotoIdControl($event)"
    ></company-photo-id-form>
    <ng-template #logoFormCreate>
      <company-logo-form
        [logoUri]="formGroup.get('logoUri')?.value"
        [companyId]="companyId"
        (uploadLogoControlSource$)="updateLogoControl($event)"
        (removeLogoSource$)="removeLogo()"
      ></company-logo-form>
    </ng-template>
  </section>
  <!--  allow customs -->
  <section
    class="form-section"
    id="allow-customs-section"
    *ngIf="placement === enumPlacement.COMPANY_PAGE && !formGroup.controls.isUnitedStates.value && !isHasOnboardingRedesign"
    [ngClass]="{ 'form-section__company-page': placement === enumPlacement.COMPANY_PAGE }"
  >
    <company-allow-customs [formGroup]="formGroup" [isShowDescription]="placement === enumPlacement.COMPANY_PAGE"></company-allow-customs>
  </section>

  <!--Payments & Billing Settings-->
  <company-block-card
    *ngIf="placement === enumPlacement.COMPANY_PAGE"
    [title]="'LABELS.PAYMENT_AND_BILLING_SETTINGS'"
    [explanationSubTitle]="'LABELS.PAYMENT_AND_BILLING_SETTINGS_SUBTITLE'"
  >
    <ng-container card-body>
      <!-- Duties payment type -->
      <section
        class="form-section form-section__separate-block company-duties-payment"
        id="company-duties-payment"
        [ngClass]="{ 'form-section__company-page': placement === enumPlacement.COMPANY_PAGE }"
        *ngIf="
          !!formGroup.controls.achIsProvided &&
          ((!formGroup.controls.isUnitedStates.value && formGroup.controls.isAllowedForCustoms.value) ||
            formGroup.controls.isUnitedStates.value)
        "
      >
        <company-duties-payment-form
          [formGroup]="formGroup"
          [punDocument]="punDocument"
          [isShowDescription]="placement === enumPlacement.COMPANY_PAGE"
          [isLoadingCompanyPun]="isLoadingCompanyPun"
          (uploadDocument)="uploadDocument($event, enumDocument.ACH_APPROVAL)"
          (deleteDocument)="deleteDocument($event, enumDocument.ACH_APPROVAL)"
          (updateDocumentState)="updateDocumentState(punDocument.id, $event)"
        ></company-duties-payment-form>
      </section>
    </ng-container>
  </company-block-card>

  <div class="container" [ngClass]="{ 'company-form__button-general': placement === enumPlacement.COMPANY_PAGE }">
    <div class="row">
      <div class="col-12 text-center">
        <button class="btn btn-primary" [disabled]="isLoadingUpsert" (click)="save()">{{ "BUTTON.SAVE" | translate }}</button>
      </div>
    </div>
  </div>
</form>

<!--Edit View-->
<form [formGroup]="formGroup" autocomplete="off" *ngIf="isEditView">
  <div class="detailed-company-container container">
    <div class="company-card" *ngIf="!editableBlocksState.isEditBusinessInfo; else editBusinessInfo">
      <div class="header-container">
        <span class="header-container__name">{{ formGroup.get("businessName").value }}</span>
        <div class="d-flex align-items-center">
          <div class="header-container__actions" *ngIf="canDeleteCompany" (click)="deleteCompanySource$.emit()">
            <img src="assets/icons/icon_trash.svg" />
            <span *ngIf="!(isTablet$ | async)">{{ "BUTTON.DELETE" | translate }}</span>
          </div>
          <div class="header-container__actions" *ngIf="!isRegistrationInProcess" (click)="openEditableBlock('isEditBusinessInfo')">
            <img src="assets/icons/edit_gray.svg" />
            <span *ngIf="!(isTablet$ | async)">{{ "BUTTON.EDIT" | translate }}</span>
          </div>
          <div class="header-container__actions" *ngIf="isRegistrationInProcess">
            <img src="assets/icons/icon_sync.svg" class="rotating" />
            <span class="underline">{{ "LABELS.SYNCHRONIZING_CBP" | translate }}</span>
            <div class="header-container__actions-tooltip">
              <app-hint-tooltip-icon [hint]="enumHintKey.syncWithCbp"></app-hint-tooltip-icon>
            </div>
          </div>
        </div>
      </div>

      <div class="info-container">
        <div class="info-container__logo" *ngIf="companyThumbnailUrl">
          <img [src]="companyThumbnailUrl" (error)="onPhotoIdImageError()" />
        </div>
        <div class="w-100">
          <div class="info-container__item">
            <span class="label">{{ "LABELS.BUSINESS_TYPE" | translate }}</span>
            <span class="value" *ngIf="formGroup.get('businessType')?.value">
              {{ "BUSINESS_TYPE." + enumCompanyBusinessType[formGroup.get("businessType").value] | translate }}
            </span>
          </div>
          <!-- #13188 State of Incorporation (read-only summary) -->
          <div class="info-container__item" *ngIf="stateOfIncorporationText">
            <span class="label">{{ "FORM_LABEL.STATE_OF_INCORPORATION" | translate }}</span>
            <span class="value">{{ stateOfIncorporationText }}</span>
          </div>
          <div class="info-container__item">
            <span class="label">{{ "LABELS.BUSINESS_ID_NUMBER" | translate }}</span>

            <span
              class="value"
              [ngClass]="{ 'cbp-pending': isCbpRegistrationPending }"
              *ngIf="!!company?.identifierQualifier || isCbpRegistrationPending"
            >
              {{
                isCompanyWithCbpAssignedNumberRequested
                  ? isCbpRegistrationCompleted(company)
                    ? ("LABELS.ASSIGNED_CBP_NUMBER" | translate) + ": "
                    : ""
                  : (company?.identifierQualifier | identifierQualifier | translate)
              }}
              {{ companyIdentifier }}
            </span>

            <span class="value text-error" *ngIf="!company?.identifierQualifier && isCbpRegistrationRejected(company)">
              {{ "LABELS.REGISTRATION_REJECTED" | translate }}
            </span>
          </div>
          <div class="info-container__item">
            <span class="label">{{ "LABELS.BUSINESS_ADDRESS" | translate }}</span>
            <span class="value">{{ companyAddressLine }}</span>
          </div>
          <div class="info-container__item" *ngIf="!isHasOnboardingRedesign">
            <span class="label">{{ "LABELS.SHIPPING_PROFILE_DEFINITIONS" | translate }}</span>
            <span class="value">
              {{ "LABELS.SHIPPING_PROFILE_DEFINITIONS_TYPES." + enumShippingRole[formGroup.get("shippingRole").value] | translate }}
            </span>
          </div>
          <div
            class="info-container__item"
            *ngIf="
              ((!formGroup.get('isUnitedStates').value && formGroup.get('isAllowedForCustoms').value) ||
                formGroup.get('isUnitedStates').value) &&
              lastDependency?.state
            "
          >
            <span class="label">{{ "LABELS.COMPANY_REGISTRATION_STATUS_LABEL" | translate }}</span>
            <span class="value" *ngIf="!!lastDependency" [ngStyle]="{ color: registrationCompanyTextColor }">
              {{ this.registrationCompanyText | translate }}
            </span>
          </div>
          <ng-container>
            <div class="info-container__item info-container__item-centered">
              <span class="label">{{ "LABELS.COMPANY_MEMBERS_LABEL" | translate }}</span>
              <div class="value">
                <app-gravatar
                  *ngFor="let organizationMember of uniqueOrganizationMembers"
                  [acronymText]="organizationMember.user.firstName.charAt(0) + organizationMember.user.lastName.charAt(0)"
                  [isNotificationOn]="organizationMember.role === enumOrganizationMemberRole.ADMIN"
                />
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <!--  Power of attorney-->
    <!-- shown in a normal view, below exists duplicated section for edit business info -->
    <ng-container
      *ngIf="
        (!formGroup.controls.isUnitedStates.value && formGroup.controls.isAllowedForCustoms.value) ||
        (formGroup.controls.isUnitedStates.value && !editableBlocksState.isEditBusinessInfo)
      "
    >
      <ng-container *ngIf="isPoaDocusignEnabled; else legacyPoaBottom">
        <company-power-attorney
          [poaDocument]="poaDocument"
          [companyId]="company?.id"
          [organizationId]="organization?.id"
          [isShowSubheader]="true"
          [isShowDescription]="!poaDocument"
          [isLoadingCompanyPoa]="isLoadingCompanyPoa"
          [isTablet]="isTablet$ | async"
          [isRegistrationApproved]="lastDependency?.state === enumDependencyState.ACCEPTED"
          [identifierQualifier]="identifierQualifier"
          [allowManualBeforeApproval]="isEditView"
          [isRequiredFieldsComplete]="isPoaFieldsComplete"
          (uploadDocument)="uploadDocument($event, enumDocument.POWER_OF_ATTORNEY)"
          (deleteDocument)="deleteDocument($event, enumDocument.POWER_OF_ATTORNEY)"
          (updateDocumentState)="updateDocumentState(poaDocument.id, $event)"
          (requestSaveBeforeSign)="onSaveBeforeDigitalSign()"
        ></company-power-attorney>
      </ng-container>
      <ng-template #legacyPoaBottom>
        <company-power-attorney-old
          [poaDocument]="poaDocument"
          [isShowSubheader]="true"
          [isShowDescription]="!poaDocument"
          [isLoadingCompanyPoa]="isLoadingCompanyPoa"
          [isTablet]="isTablet$ | async"
          (uploadDocument)="uploadDocument($event, enumDocument.POWER_OF_ATTORNEY)"
          (deleteDocument)="deleteDocument($event, enumDocument.POWER_OF_ATTORNEY)"
          (updateDocumentState)="updateDocumentState(poaDocument.id, $event)"
        ></company-power-attorney-old>
      </ng-template>
    </ng-container>

    <!--  company logo / photo id -->
    <section
      class="form-section"
      id="company-logo"
      *ngIf="placement === enumPlacement.COMPANY_PAGE && editableBlocksState.isEditBusinessInfo"
      [ngClass]="{ 'form-section__company-page': placement === enumPlacement.COMPANY_PAGE }"
    >
      <company-photo-id-form
        *ngIf="isPhotoIdBusinessType; else logoFormEdit"
        [photoIdUri]="photoIdDownloadUrl"
        [companyId]="companyId"
        [isLoading]="isLoadingPhotoId"
        [isNonImageDocument]="!!photoIdDocument && !photoIdIsImage"
        [fileName]="photoIdDocument?.fileName"
        (uploadPhotoIdSource$)="updatePhotoIdControl($event)"
      ></company-photo-id-form>
      <ng-template #logoFormEdit>
        <company-logo-form
          [logoUri]="formGroup.get('logoUri')?.value"
          [companyId]="companyId"
          (uploadLogoControlSource$)="updateLogoControl($event)"
          (removeLogoSource$)="removeLogo()"
        ></company-logo-form>
      </ng-template>
    </section>
    <!--  allow customs -->
    <section
      class="form-section"
      id="allow-customs-section"
      *ngIf="showAllowCustomsInEditMode"
      [ngClass]="{ 'form-section__company-page': placement === enumPlacement.COMPANY_PAGE }"
    >
      <company-allow-customs [formGroup]="formGroup" [isShowDescription]="placement === enumPlacement.COMPANY_PAGE"></company-allow-customs>
    </section>

    <!--    //TODO: remove all code after new bonds-->
    <ng-container
      *ngIf="
        !!company.validationDate &&
        ((!formGroup.controls.isUnitedStates.value && formGroup.controls.isAllowedForCustoms.value) ||
          formGroup.controls.isUnitedStates.value)
      "
    >
      <div class="container bonds-section" id="control-defaultBondReferenceNumber">
        <div class="form-row">
          <div class="col-12">
            <div class="bonds-section__header">{{ "COMPANY.CUSTOMS_BOND" | translate }}</div>
          </div>
          <div class="col-12">
            <div
              *ngIf="validBondLength"
              [innerHtml]="
                (validBondLength > 1 ? 'COMPANY.CUSTOMS_BOND_DESC' : 'COMPANY.CUSTOMS_BOND_DESC_SINGLE')
                  | translate : { length: validBondLength }
              "
              class="form-section-description pt-2 pb-2"
            ></div>
          </div>
        </div>
        <div class="form-row pt-2 pb-2">
          <div *ngIf="!validBondLength" class="col-12" [innerHTML]="'COMPANY.CUSTOMS_BOND_NOT_FOUND' | translate"></div>

          <div class="col-12 d-flex justify-content-between flex-wrap">
            <button
              *ngIf="showPurchaseContinuousBondButton"
              class="btn btn-link"
              [routerLink]="!!(isDesktop$ | async) ? ['/bonds'] : ['/companies', 'bond-request', 'edit']"
            >
              {{ "BUTTON.PURCHASE_CONTINUOUS_BOND" | translate }}
            </button>

            <button class="btn btn-link" (click)="updateCompanyBonds()">
              {{ "BUTTON.SYNCHRONIZE_WITH_CBP" | translate }}
            </button>
          </div>

          <div *ngIf="company?.bondRequest && company?.bondRequest.state !== enumBondRequestState.COMPLETED" class="col-12">
            <company-bond-request-card
              [companyId]="company.id"
              [bondRequest]="company?.bondRequest"
              (delete)="deleteBondRequest()"
            ></company-bond-request-card>
          </div>

          <div *ngFor="let bond of singleBonds; let i = index; let last = last" class="col-12" [ngClass]="{ 'mb-2': !last }">
            <company-bond-card [id]="'bond-single-' + i" [bond]="bond" [isShowStatusTag]="true"></company-bond-card>
          </div>

          <div *ngFor="let bond of continuousBonds; let i = index; let last = last" class="col-12" [ngClass]="{ 'mb-2': !last }">
            <company-bond-card
              [fc]="formGroup.get('defaultBondReferenceNumber')"
              [bond]="bond"
              [isShowStatusTag]="true"
              [id]="'bond-continuous-' + i"
            ></company-bond-card>
          </div>
        </div>
      </div>
    </ng-container>

    <!--Payments & Billing Settings-->
    <company-block-card
      [title]="'LABELS.PAYMENT_AND_BILLING_SETTINGS'"
      [explanationSubTitle]="'LABELS.PAYMENT_AND_BILLING_SETTINGS_SUBTITLE'"
    >
      <ng-container card-body>
        <!-- Duties payment type -->
        <ng-container
          *ngIf="
            (!formGroup.controls.isUnitedStates.value && formGroup.controls.isAllowedForCustoms.value) ||
            formGroup.controls.isUnitedStates.value
          "
        >
          <div class="duties-payment-card" *ngIf="!editableBlocksState.isEditDutiesPayment; else editDutiesPayment">
            <div class="header-container">
              <span class="header-container__name">{{ "LABELS.DUTIES_PAYMENT_TYPE" | translate | uppercase }}</span>
              <div class="header-container__actions" (click)="openEditableBlock('isEditDutiesPayment')">
                <img src="assets/icons/edit_gray.svg" />
                <span *ngIf="!(isTablet$ | async)">{{ "BUTTON.EDIT" | translate }}</span>
              </div>
            </div>
            <div class="info-container d-flex flex-column">
              <span class="info-container__ach-value">{{ "COMPANY." + paymentTypeText | translate }}</span>
              <div class="info-container__ach-number" *ngIf="this.formGroup.get('achIsProvided')?.value">
                <span>{{ "LABELS.PAYER_UNIT_NUMBER_PUN_CBP" | translate }}</span>
                <span>{{ formGroup.get("payerUnitNumber")?.value }}</span>
              </div>

              <document-upload-desktop
                *ngIf="this.formGroup.get('achIsProvided')?.value"
                [id]="'pun-document'"
                [attachmentName]="'COMPANY.ACH_ACCOUNT_APPROVAL' | translate"
                [attachmentHint]="'COMPANY.ACH_ACCOUNT_APPROVAL_ATTACHMENT' | translate"
                [uploadedDocument]="punDocument"
                [canUploadDocuments]="false"
                [canRemoveDocuments]="false"
                [canDownloadDocuments]="true"
                [isShowOptionalTag]="false"
                [isShowFooter]="false"
                [isShowDownloadFile]="true"
                [isShowFileDate]="true"
                [isStretched]="true"
                [isDividedLayout]="true"
              ></document-upload-desktop>
              <span class="info-container__ach-example-label" *ngIf="!this.formGroup.get('achIsProvided')?.value">
                {{ "COMPANY.DUTIES_PAYMENT_TYPE_DESCRIPTION" | translate }}
                <a href="https://www.cbp.gov/document/forms/form-400-ach-application" target="_blank" class="link">
                  {{ "LABELS.APPLY_HERE" | translate }}
                </a>
              </span>
            </div>
          </div>
        </ng-container>

        <ng-template #editDutiesPayment>
          <!--    Company duties payment-->
          <div class="editable-container">
            <section
              class="form-section form-section__separate-block company-duties-payment"
              id="company-duties-payment"
              [ngClass]="{ 'form-section__company-page': placement === enumPlacement.COMPANY_PAGE }"
              *ngIf="
                !!formGroup.controls.achIsProvided &&
                ((!formGroup.controls.isUnitedStates.value && formGroup.controls.isAllowedForCustoms.value) ||
                  formGroup.controls.isUnitedStates.value)
              "
            >
              <company-duties-payment-form
                [formGroup]="formGroup"
                [punDocument]="punDocument"
                [isShowDescription]="placement === enumPlacement.COMPANY_PAGE"
                [isLoadingCompanyPun]="isLoadingCompanyPun"
                (uploadDocument)="uploadDocument($event, enumDocument.ACH_APPROVAL)"
                (deleteDocument)="deleteDocument($event, enumDocument.ACH_APPROVAL)"
                (updateDocumentState)="updateDocumentState(punDocument.id, $event)"
              ></company-duties-payment-form>
            </section>
            <div class="action-buttons-container">
              <button
                type="button"
                class="action-buttons-container__button action-buttons-container__button-secondary"
                (click)="cancelEditableBlock('isEditDutiesPayment')"
              >
                {{ "BUTTON.CANCEL" | translate }}
              </button>
              <button
                type="button"
                class="btn btn-primary action-buttons-container__button action-buttons-container__button-primary"
                [disabled]="!formGroup.dirty"
                (click)="save()"
              >
                {{ "BUTTON.SAVE_CHANGES" | translate }}
              </button>
            </div>
          </div>
        </ng-template>

        <ng-container>
          <section class="form-section form-section__separate-block company-payment-method-card" id="company-payment-method-card">
            <loading-spinner [show]="isLoadingPaymentMethods"></loading-spinner>
            <company-payment-method
              [company]="company"
              [allPaymentMethods]="allPaymentMethods"
              [paymentMethods]="paymentMethods"
              [pendingBills]="monthlyBillList"
              [isLoading]="isLoadingPaymentForm"
              [isPayPalPaymentTokenLoading]="isPayPalPaymentTokenLoading"
              (payNow)="payMonthlyBill($event)"
              (deletePayment)="deletePayment.emit($event)"
              (paypalPaymentToken)="paypalPaymentToken.emit()"
              *ngIf="!isLoadingPaymentMethods"
            ></company-payment-method>
          </section>
        </ng-container>
      </ng-container>
    </company-block-card>
  </div>

  <ng-template #editBusinessInfo>
    <div class="editable-container">
      <!--    business info -->
      <section
        class="form-section"
        id="business-info-section"
        [ngClass]="{ 'form-section__company-page': placement === enumPlacement.COMPANY_PAGE }"
      >
        <company-business-info-form
          [company]="company"
          [isEditView]="isEditView"
          [formGroup]="formGroup"
          [isFirstCompany]="isFirstCompany"
          [isShowDescription]="placement === enumPlacement.COMPANY_PAGE"
          [isRegistrationInProcess]="isRegistrationInProcess"
          [lastDependencyErrorCodes]="lastDependencyErrorCodes"
          [lastDependency]="lastDependency"
          [ss4Document]="ss4Document"
          [ss4DownloadUrl]="ss4DownloadUrl"
          [isLoadingSs4]="isLoadingSs4"
          [isSs4Image]="ss4IsImage"
          [isPoaGrandfathered]="isPoaGrandfathered"
          (applyForAssignedCbpNumber)="applyForAssignedCbpNumber()"
          (ss4Selected$)="updateSs4Control($event)"
        ></company-business-info-form>
      </section>

      <!--    user phone -->
      <section class="form-section" id="user-phone-section" *ngIf="showUserPhone">
        <company-user-phone [formGroup]="formGroup"></company-user-phone>
      </section>

      <!--    business address -->
      <section
        class="form-section"
        id="business-address-section"
        [ngClass]="{ 'form-section__company-page': placement === enumPlacement.COMPANY_PAGE }"
      >
        <company-address-form
          [formGroup]="formGroup"
          [isShowDescription]="placement === enumPlacement.COMPANY_PAGE"
          [isDisableCountry]="isDisableCountry"
        ></company-address-form>
      </section>

      <!--    #13269 controlling persons (beneficial owners / partners) -->
      <section
        class="form-section"
        id="controlling-persons-section"
        *ngIf="placement === enumPlacement.COMPANY_PAGE"
        [ngClass]="{ 'form-section__company-page': placement === enumPlacement.COMPANY_PAGE }"
      >
        <company-controlling-persons-form
          [formGroup]="formGroup"
          [isShowDescription]="placement === enumPlacement.COMPANY_PAGE"
          [personDocuments]="controllingPersonDocuments"
          [scanBuffer]="controllingPersonScans"
          [scanUrls]="controllingPersonScanUrls"
          [uploadingGroups]="controllingPersonUploadingGroups"
          [scanErrors]="controllingPersonScanErrors"
          (scanSelected$)="onControllingPersonScanSelected($event)"
          (personRemoved$)="onControllingPersonRemoved($event)"
          (retryScanUpload$)="onControllingPersonScanRetry($event)"
        ></company-controlling-persons-form>
      </section>

      <!--    IOR contact information -->
      <section
        class="form-section"
        id="ior-contact-section"
        [ngClass]="{ 'form-section__company-page': placement === enumPlacement.COMPANY_PAGE }"
      >
        <company-ior-contact-form
          [formGroup]="formGroup"
          [isShowDescription]="placement === enumPlacement.COMPANY_PAGE"
        ></company-ior-contact-form>
      </section>

      <!--    Employee status -->
      <section
        *ngIf="showEmployeeStatus"
        class="form-section"
        id="employee-status-section"
        [ngClass]="{ 'form-section__company-page': placement === enumPlacement.COMPANY_PAGE }"
      >
        <company-employee-status [organization]="organization"></company-employee-status>
      </section>

      <!--  shipping role -->
      <section
        class="form-section"
        id="shipping-profile-definitions"
        *ngIf="placement === enumPlacement.COMPANY_PAGE && !isHasOnboardingRedesign"
        [ngClass]="{ 'form-section__company-page': placement === enumPlacement.COMPANY_PAGE }"
      >
        <company-shipping-role
          [formGroup]="formGroup"
          [isShowDescription]="placement === enumPlacement.COMPANY_PAGE"
        ></company-shipping-role>
      </section>

      <!--  Power of attorney-->
      <!-- shown only if user is editing business info. above exists same section for for normal company page view -->
      <section
        id="power-of-attorney"
        *ngIf="
          (!formGroup.controls.isUnitedStates.value && formGroup.controls.isAllowedForCustoms.value) ||
          formGroup.controls.isUnitedStates.value
        "
      >
        <ng-container *ngIf="isPoaDocusignEnabled; else legacyPoaBottom">
          <company-power-attorney
            [poaDocument]="poaDocument"
            [companyId]="company?.id"
            [organizationId]="organization?.id"
            [isShowSubheader]="true"
            [isShowDescription]="!poaDocument"
            [isLoadingCompanyPoa]="isLoadingCompanyPoa"
            [isTablet]="isTablet$ | async"
            [isRegistrationApproved]="lastDependency?.state === enumDependencyState.ACCEPTED"
            [identifierQualifier]="identifierQualifier"
            [allowManualBeforeApproval]="isEditView"
            [isRequiredFieldsComplete]="isPoaFieldsComplete"
            (uploadDocument)="uploadDocument($event, enumDocument.POWER_OF_ATTORNEY)"
            (deleteDocument)="deleteDocument($event, enumDocument.POWER_OF_ATTORNEY)"
            (updateDocumentState)="updateDocumentState(poaDocument.id, $event)"
            (requestSaveBeforeSign)="onSaveBeforeDigitalSign()"
          ></company-power-attorney>
        </ng-container>
        <ng-template #legacyPoaBottom>
          <company-power-attorney-old
            [poaDocument]="poaDocument"
            [isShowSubheader]="true"
            [isShowDescription]="!poaDocument"
            [isLoadingCompanyPoa]="isLoadingCompanyPoa"
            [isTablet]="isTablet$ | async"
            (uploadDocument)="uploadDocument($event, enumDocument.POWER_OF_ATTORNEY)"
            (deleteDocument)="deleteDocument($event, enumDocument.POWER_OF_ATTORNEY)"
            (updateDocumentState)="updateDocumentState(poaDocument.id, $event)"
          ></company-power-attorney-old>
        </ng-template>
      </section>

      <div class="action-buttons-container">
        <button
          type="button"
          class="action-buttons-container__button action-buttons-container__button-secondary"
          (click)="cancelEditableBlock('isEditBusinessInfo')"
        >
          {{ "BUTTON.CANCEL" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-primary action-buttons-container__button action-buttons-container__button-primary"
          [disabled]="isLoadingUpsert"
          (click)="save()"
        >
          {{ "BUTTON.SAVE_CHANGES" | translate }}
        </button>
      </div>
    </div>
  </ng-template>
</form>

<missing-fields
  [code]="isEditView ? '' : 'MENU.CREATE_COMPANY'"
  [descriptionText1]="isEditView ? 'INCORRECT_INFORMATION.TEXT_1_EDIT_COMPANY' : 'INCORRECT_INFORMATION.TEXT_1'"
  [descriptionText2]="isEditView ? 'INCORRECT_INFORMATION.TEXT_2_EDIT_COMPANY' : 'INCORRECT_INFORMATION.TEXT_2'"
  [confirmTitle]="'EDIT_NOW'"
  (decline)="save(false)"
></missing-fields>

<custom-modal size="lg" [header]="'COMPANY.PUN_MODAL.HEADER'" [open]="showPUNExampleModal" (openChange)="showPUNExampleModal = false">
  <p [innerHTML]="'COMPANY.PUN_MODAL.PARAGRAPH_DATE' | translate"></p>
  <p>
    <span [innerHTML]="'COMPANY.PUN_MODAL.PARAGRAPH_ACH_1' | translate"></span>
    <b class="hint-text" [innerHTML]="'COMPANY.PUN_MODAL.PARAGRAPH_ACH_2' | translate"></b>
    <span [innerHTML]="'COMPANY.PUN_MODAL.PARAGRAPH_ACH_3' | translate"></span>
  </p>
  <p [innerHTML]="'COMPANY.PUN_MODAL.PARAGRAPH_BROKERS_AND_SELF_FILERS' | translate"></p>
  <p [innerHTML]="'COMPANY.PUN_MODAL.PARAGRAPH_IMPORTERS' | translate"></p>
  <p [innerHTML]="'COMPANY.PUN_MODAL.PARAGRAPH_ATTACHED' | translate"></p>
  <p [innerHTML]="'COMPANY.PUN_MODAL.PARAGRAPH_ANY_QUESTIONS' | translate"></p>
</custom-modal>
<custom-modal
  [header]="'COMPANY.PUN_MODAL.VALIDATION.DOCUMENT.HEADER'"
  [open]="showPUNDocValidationModal"
  (openChange)="showPUNDocValidationModal = false"
>
  <p [innerHTML]="'COMPANY.PUN_MODAL.VALIDATION.DOCUMENT.TEXT' | translate"></p>
</custom-modal>

<custom-modal
  [header]="'COMPANY.PUN_MODAL.VALIDATION.CHECKBOX.HEADER'"
  [open]="showPUNCheckboxValidationModal"
  (openChange)="showPUNCheckboxValidationModal = false"
>
  <p [innerHTML]="'COMPANY.PUN_MODAL.VALIDATION.CHECKBOX.TEXT' | translate"></p>
</custom-modal>

<!-- #13189 banned registered-agent address — hard block, close-only -->
<custom-modal
  [header]="'COMPANY.BANNED_ADDRESS.MODAL_HEADER'"
  [open]="showBannedAddressModal"
  (openChange)="showBannedAddressModal = false"
>
  <p [innerHTML]="'COMPANY.BANNED_ADDRESS.TEXT' | translate"></p>
</custom-modal>

<custom-modal [header]="'BUTTON.SAVE_CHANGES'" [(open)]="showFormBlockSavedModal">
  <p class="font-weight-bold" [innerHTML]="'COMPANY.SAVE_CHANGES_MODAL.QUESTION' | translate"></p>
  <p [innerHTML]="'COMPANY.SAVE_CHANGES_MODAL.DESCRIPTION' | translate"></p>

  <button footer-action type="button" class="btn btn-primary" (click)="discardChanges()">{{ "BUTTON.CANCEL" | translate }}</button>

  <button footer-action type="button" class="btn btn-secondary ml-2" (click)="saveChanges()">
    {{ "BUTTON.SAVE_CHANGES" | translate }}
  </button>
</custom-modal>

<loading-spinner [show]="isLoadingUpsert" [config]="{ fullScreenBackdrop: true }"></loading-spinner>
